import React from 'react'
import { Card } from 'react-bootstrap'
import styled from 'styled-components'

interface HeaderProps {
  $gradient: string
}

export const StepHeader = styled.div<HeaderProps>`
  background: ${(props) => props.$gradient};
  padding: 1.25rem 1.5rem;
  border-radius: 8px 8px 0 0;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;

  .lock-icon-container {
    margin-left: auto;
    display: flex;
    align-items: center;
    z-index: 3;
    opacity: 1 !important;
  }

  @media (max-width: 768px) {
    padding: 1rem 1.25rem;
  }
`

export const StepContent = styled.div`
  background: #2a2a2a;
  padding: 1.5rem;
  border-radius: 0 0 8px 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  min-height: 0;

  @media (max-width: 768px) {
    padding: 1.25rem;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #1a1a1a;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #4a4a4a;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #5a5a5a;
  }
`

export const StepCard = styled(Card)`
  background: #2a2a2a;
  border: none;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 0;
  border-radius: 8px;

  &.locked {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      z-index: 1;
      pointer-events: none;
    }

    .step-header {
      position: relative;
      z-index: 2;

      > *:not(.lock-icon-container) {
        opacity: 0.5;
      }
    }

    .step-content {
      position: relative;
      z-index: 0;
      opacity: 0.5;
    }
  }
`

interface StepCardProps {
  children: React.ReactNode
  className?: string
}

export const BaseStepCard: React.FC<StepCardProps> = ({ children, className }) => {
  return <StepCard className={className}>{children}</StepCard>
}
